import React, { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, Label, FormGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import axios from "axios";
import { API_URL } from "helpers/app_url";
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import "./rsbutton.css"

import rsAilogo from "../../assets/img/rs-ai-logo.png";
import SafeField from "helpers/SafeField";


class AiButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showAIAssistantModal: false,
            generatedContent: "",
            showInsert: false,
        }
    }
    render() {
        return (
            <React.Fragment>
                <Link to="#"
                    className="btn btn-outline-secondary btn-ai"
                    onClick={(e) => {
                        e.preventDefault();
                        this.setState({ showAIAssistantModal: true });
                    }}
                > <img src={rsAilogo} style={{ width: 20 }} /> A.I Assist</Link>
                <Modal
                    isOpen={this.state.showAIAssistantModal}
                    toggle={() => this.setState({ showAIAssistantModal: false })}
                    size="md"
                    centered
                >
                    <ModalHeader toggle={() => this.setState({ showAIAssistantModal: false })}>
                        A.I Assistant
                    </ModalHeader>
                    <Formik
                            enableReinitialize={true}
                            initialValues={{
                                message: '',

                            }}
                            validationSchema={Yup.object().shape({
                                message: Yup.string().required("This is required")
                            })}

                            onSubmit={async (values, { setFieldValue }) => {
                                try {
                                    const obj = JSON.parse(localStorage.getItem("authUser"));
                                    const token = obj?.resultData?.bearerToken;
                                    const headers = {
                                        Authorization: `Bearer ${token}`,
                                        "Content-Type": "application/json",
                                    };
                                    const response = await axios.post(`${API_URL}Gmail/getContentFromAI`, values, { headers });
                                    if (response.status === 200 || response.status === 201) {
                                        const generated = response.data.message;
                                        setFieldValue('content', generated);
                                        this.setState({ showInsert : true });
                                    }
                                } catch (error) {
                                    console.error("AI generation error", error);
                                }
                            }}

                        >
                            {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                                <Form
                                    className="needs-validation"
                                >
                    <ModalBody>
                       

                                    <Row>

                                        <Col md="9">

                                            <FormGroup className="mb-3">
                                                <Label htmlFor="message">Enter a prompt</Label>
                                                <SafeField
                                                    name="message"
                                                    className={
                                                        "form-control" +
                                                        (errors.message && touched.message
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                    onChange={handleChange}
                                                    type="text"
                                                />
                                                <ErrorMessage
                                                    name="message"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="3">
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                style={{ marginTop: 30, borderRadius: 5 }}
                                            >
                                                Generate
                                            </button>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup>
                                                <Label htmlFor="message">Generated Content</Label>
                                                <Field
                                                    as="textarea"
                                                    className={`form-control ${touched.content && errors.content ? 'is-invalid' : ''}`}
                                                    name="content"
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                              
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <button className="btn btn-update" 
                                style={{ display: this.state.showInsert ? 'block' : 'none', marginRight: 10 }}
                                onClick={() => {
                                    if (this.props.onInsert) {
                                    this.props.onInsert(values.content);
                                    }
                                    this.setState({ showAIAssistantModal: false });
                                }}>
                                Insert</button></div>
                        <Button color="secondary" onClick={() => this.setState({ showAIAssistantModal: false })}>
                            Close
                        </Button>
                    </ModalFooter>
                    </Form>
                            )}
                        </Formik>
                </Modal>

            </React.Fragment>
        )
    }
}


AiButton.propTypes = {
    onInsert: PropTypes.func
}


export default AiButton